export default {
  rewardsWelcomeMessage:
    "Welcome to Wellth Rewards, {0}, where you can earn rewards for being healthy! Get the Wellth app at ",
  restfulWelcomeMessage:
    "Welcome to Restful, {0}! We want you to earn rewards for getting a great night's sleep. Download the Restful app to get started: ",
};
